<template>
  <div class="dialog dialog-sale" v-if="isShown">
		<div class="dialog-bg"></div>
	
		<div class="dialog-container">
			<div class="title">
				<i @click="close"></i>
				<p>订阅</p>
			</div>
			<div class="con">
				<div class="con-l">
					<p>组队活动进度提醒</p>
					<!-- <span>福利上新第一时间通知您</span> -->
				</div>
				<div class="con-r">
					<label class="txms-mod-switch txms-mod-switch--green">
						<div class="txms-mod-switch__target">
                            <input
                              v-model="subscribeStatus"
                              aria-labelledby="l1"
                              class="txms-switch"
                              type="checkbox"
                              :disabled="btnLock"
                              @click="subscribeBiz"
                            />
						</div>
					</label>
				</div>
			</div>
			<img class="logo" src="~2021team-pk-ui/assets/pay-logo.png" alt="">
		</div>
	
	</div>
</template>

<script>
import myMinin from "./mixin"
import { mapActions } from "vuex"

export default {
  name: "Present",
  props: ["gameInfo", "isShown"],
  mixins: [myMinin],
  computed: {
    subscribeId() {
      return this.gameInfo?.subscribeGroups
    }
  },
  data() {
    return {
      subscribeStatus: false,
      btnLock: false
    }
  },
  methods: {
    ...mapActions(["subscribeActivity", "setToastMsg"]),
    subscribeBiz() {
      if (this.btnLock) return
      this.$emit("setLoading", true)
      this.btnLock = true
      if (this.subscribeStatus) {
        this.subscribeActivity("cancel")
          .then(res => {
            if (res?.ret == 0) {
              this.subscribeStatus = false
            } else {
              this.subscribeStatus = true
              this.$emit("setToastMsg", "退订失败，请稍后重试")
            }
          })
          .catch(() => {
            this.subscribeStatus = true
            this.$emit("setToastMsg", "退订失败，请稍后重试")
          })
          .finally(() => {
            this.btnLock = false
            this.$emit("setLoading", false)
          })
      } else {
        this.subscribeActivity("subscribe")
          .then(res => {
            if (res?.ret == 0) {
              this.subscribeStatus = true
              this.$emit("showFollowDialog")
              this.$emit("setLoading", false)
              this.close()
            } else {
              this.subscribeStatus = false
              this.$emit("setToastMsg", "订阅失败，请稍后重试")
            }
          })
          .catch(() => {
            this.subscribeStatus = false
            this.$emit("setToastMsg", "订阅失败，请稍后重试")
          })
          .finally(() => {
            this.btnLock = false
            this.$emit("setLoading", false)
          })
      }
    }
  },
  mounted() {
    this.$emit("setLoading", true)
    this.subscribeActivity("query_subscribe").then(res => {
      this.$emit("setLoading", false)
      if (res?.ret == 0 && res?.info?.subscribe_groups) {
        res.info.subscribe_groups.map(group => {
          if (group.FGroupID == this.subscribeId) {
            this.subscribeStatus = true
          }
        })
      }
    })
  }
}
</script>

<style scoped>
</style>
